// src/firebaseConfig.js
// VERSIÓN CORREGIDA - Simple y directa

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDvq07SoekqERDszQ6cS0Y7lPFYqLNoKl8",
  authDomain: "liceo-activity-manager.firebaseapp.com",
  projectId: "liceo-activity-manager",
  storageBucket: "liceo-activity-manager.firebasestorage.app",
  messagingSenderId: "1002499533304",
  appId: "1:1002499533304:web:1471c54a5f2382badcce0d",
  measurementId: "G-T1JXPVKQGG"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios principales
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
